import Swal from 'sweetalert2';
import {
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS,
} from '../../Types/user/Types';
import { workspace_Supporting_DocumentFolder_CreateApi } from '../../Apis/user/ApiConfig';

export const workspaces_Supporting_document_FolderCreate_Success = (res) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS,
        payload: res,
    };
};
export const workspaces_Supporting_document_FolderCreate_Error = (error) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR,
        error: error,
    };
};

export const workspaces_Supporting_document_FolderCreate_Request = (res) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST,
        payload: res,
    };
};

export const clearEditDataWorkspace = () => ({
    type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR,
});

export const workspaces_Supporting_Document_FolderCreate_ActionHandler = (
    values
) => {
    return (dispatch) => {
        dispatch(workspaces_Supporting_document_FolderCreate_Request());
        try {
            workspace_Supporting_DocumentFolder_CreateApi(values)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 201) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Folder created successfully!',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            dispatch(
                                workspaces_Supporting_document_FolderCreate_Success(
                                    res?.data
                                )
                            );
                        } else {
                            let data = res?.response?.data?.data;
                            let errors = res?.response?.data?.errors;
                            let errorMessage = '';
                            console.log(data, 'DATA IS THERE');
                            if (errors != undefined && errors != null) {
                                Object.values(errors).map((key, error) => {
                                    errorMessage += key[0] + '<br/>';
                                });
                            }

                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                                html: `<p>${errorMessage || data}</p>`,
                                confirmButtonColor: 'rgb(231,52,70)',
                            });
                            dispatch(
                                workspaces_Supporting_document_FolderCreate_Error(
                                    res
                                )
                            );
                        }
                    } else {
                        dispatch(
                            workspaces_Supporting_document_FolderCreate_Error(
                                ''
                            )
                        );
                    }
                })
                .catch((err) => {
                    dispatch(
                        workspaces_Supporting_document_FolderCreate_Error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(workspaces_Supporting_document_FolderCreate_Error(err));
        }
    };
};
